import { render, staticRenderFns } from "./KategoriObat.vue?vue&type=template&id=9484a5b8"
import script from "./KategoriObat.vue?vue&type=script&setup=true&lang=js"
export * from "./KategoriObat.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports